import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentConference } from '../../../base/conference/functions';
import { getParticipantCount } from '../../../base/participants/functions';
import { nudge, refresh } from '../../store';
import SiInvitePanel from './SiInvitePanel';
/**
 * Mounted once in the conference page. When the call is joined it asks once whether this person may invite SIs here
 * (a signed-in member in a Kamo meeting; a guest gets no answer and never sees the button), and whenever someone
 * joins or leaves the call it has the open panel read the list again, so an SI arriving or leaving another way shows
 * at once.
 *
 * @returns {ReactElement}
 */
export default function SiInviteHost() {
    const joined = useSelector((state) => Boolean(getCurrentConference(state)));
    const count = useSelector((state) => getParticipantCount(state));
    const asked = useRef(false);
    useEffect(() => {
        if (joined && !asked.current) {
            asked.current = true;
            refresh();
        }
    }, [joined]);
    useEffect(() => {
        if (joined) {
            nudge();
        }
    }, [count]);
    return React.createElement(SiInvitePanel, null);
}
